import { query, mutation } from '@/services/graphql';
import * as operations from './operations';

export default {
  getBookList(variables = {}) {
    return query(operations.BOOK_LIST, variables, true);
  },
  getLevelList(variables = {}) {
    return query(operations.LEVEL_LIST, variables, true);
  },
  getLevelUserInfo(variables = {}) {
    return query(operations.LEVEL_USER_INFO, variables, true);
  },
  getLevelEnergy(variables = {}) {
    return query(operations.LEVEL_ENERGE, variables, false);
  },
  usedEnergyData(variables = {}) {
    return mutation(operations.USE_ENERGY_DATA, variables, false);
  },
};
